import { render, staticRenderFns } from "./additenwr.vue?vue&type=template&id=12f80f37&scoped=true"
import script from "./additenwr.vue?vue&type=script&lang=js"
export * from "./additenwr.vue?vue&type=script&lang=js"
import style0 from "./additenwr.vue?vue&type=style&index=0&id=12f80f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f80f37",
  null
  
)

export default component.exports